import React from 'react';
import PropTypes from 'prop-types';

// Components
import { FamilySkeleton } from '../FamilySkeleton';
import { ErrorPage } from '../ErrorPage';

const SkeletonWrapper = ({ isLoading = false, isError = false, children }) => {
  if (isLoading) {
    return <FamilySkeleton />;
  }

  if (isError) {
    return <ErrorPage />;
  }

  return <>{children}</>;
};

SkeletonWrapper.propTypes = {
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
};

export { SkeletonWrapper };
